import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";

function Client() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);
  const [ClinetData, setClientData] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [user_id, setUserID] = useState("");
  const [clientName, setClintName] = useState("");
  const [network_type, setNetworkType] = useState("");
  const [userStatus, setStatus] = useState("");
  const [viewData, setViewData] = useState("");


  const [editPaidAmount, setEditPaidAmount] = useState("");
  const [editFromAddress, setEditFromAddress] = useState("");
  const [editToAddress, setEditToAddress] = useState("");
  const [editTxnHash, setEditTxnHash] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [deposit_id, setDepositId] = useState([]);
  const [error, setError] = useState("");



  useEffect(() => {

    fetchdataClient(1);
  }, []);


  const fetchdataClient = async (page) => {
    console.log('Token ', authToken);

    const searchData = {
      page: page,
      user_id: user_id,
      name: clientName,
      user_status: userStatus,
    };

    console.log('Reach Data', searchData);

    try {
      const client = await fetch(`${baseurl}/client/data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (client.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const clientData = await client.json();
      console.log('Static data', clientData);

      if (clientData.status) {
        setAnalytics(clientData.clientCount);
        setClientData(clientData.data);
        setPagination(clientData.pagination);
        setTableLoading(true);
      } else {
        // Handle any error condition
        setTableLoading(true);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };


  const passData = (dataClient) => {
    setDepositId(dataClient);
    setViewData(dataClient);
    setEditPaidAmount(dataClient.paid_amount);
    setEditFromAddress(dataClient.from_address);
    setEditToAddress(dataClient.to_address);
    setEditTxnHash(dataClient.txn_hash);
    setEditStatus(dataClient.txn_hash);
  };



  const updateDeposit = async () => {

    console.log(editPaidAmount, editFromAddress, editToAddress, editTxnHash, editStatus)

    if (!deposit_id) return setError("Try again.");
    if (!editPaidAmount) return setError("Paid amount id required.");
    if (!editFromAddress) return setError("From address is required");
    if (!editToAddress) return setError("To address is reuired.");
    if (!editTxnHash) return setError("Txn Hash is required.");
    if (!editStatus) return setError("Status is required.");
    if (!authToken) return setError("Authentication is required.");


    const formData = {
      deposit_id: deposit_id.id,
      paid_amount: editPaidAmount,
      from_address: editFromAddress,
      to_address: editToAddress,
      txn_hash: editTxnHash,
      status: editStatus
    };

    console.log("Sending Data:", formData);

    try {
      const response = await fetch(`${baseurl}/client/deposit-update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // Get raw response
      console.log("Raw API Response:", data); // Log response before parsing


      if (data.status) {
        toast.success(data.message)
        window.location.href = "";
      }
      else {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
  }


  const handlePageChange = async (page) => {

    setTableLoading(false)
    fetchdataClient(page);
  }

  const searchData = () => {

    setTableLoading(false)
    fetchdataClient(1);
  }
  return (
    <>
      <Header>
        <Auth />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>


              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total : '0'}

                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Deposit Value
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">HOLD USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.hold : '0'}
                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Deposit Value
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">BLOCK USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.block : '0'}
                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Block User
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.active : '0'}
                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Deposit Value
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table ">
                  <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 ">
                        <lavel>User Id</lavel>
                        <input type="text" value={user_id} onChange={(e) => setUserID(e.target.value)} className="form-control" placeholder="Enter User Id" />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 ">
                        <lavel>Name</lavel>
                        <input type="text" value={clientName} onChange={(e) => setClintName(e.target.value)} className="form-control" placeholder="Enter User Id" />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3">
                        <label>Status</label>
                        <select className="form-control" value={userStatus} onChange={(e) => setStatus(e.target.value)}>
                          <option value="">All</option>
                          <option value="active">Active</option>
                          <option value="hold">Hold</option>
                          <option value="block">Block</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 text-end">

                        <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row closed */}

            {/* row opened */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">User Data</h3>
                  </div>
                  <div className="table-responsive country-table">
                    {tabelLoading ? (
                      <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                        <thead>
                          <tr>
                            <th className="wd-lg-25p">CLIENT</th>
                            <th className="wd-lg-25p">Name</th>
                            <th className="wd-lg-25p">Company Name</th>
                            <th className="wd-lg-25p">Email</th>
                            <th className="wd-lg-25p">Register</th>
                            <th className="wd-lg-25p">STATUS</th>
                            <th className="wd-lg-25p">ACTION</th>
                          </tr>
                        </thead>

                        <tbody>
                          {ClinetData.length > 0 ? (
                            ClinetData.map((dataClient, index) => (
                              <tr key={index}>
                                <td><img class="avatar avatar-md rounded-circle my-auto me-3" src={dataClient?.profile_image || 'N/A'} alt="Image description" /></td>
                                <td> {dataClient?.name || 'N/A'} </td>
                                <td> {dataClient?.company_name || 'N/A'} </td>
                                <td> {dataClient?.email || '0'} </td>
                                <td> {dataClient?.created_at || 'N/A'} </td>
                                <td>
                                  {dataClient && dataClient?.user_status
                                    ? dataClient?.user_status === 'active' ? (
                                      <span className="badge bg-success">Active</span>
                                    ) : (
                                      <span className="badge bg-danger">{dataClient?.user_status} </span>
                                    ) : 'N/A'}
                                </td>
                                <td>
                                  <a href="/clientsDetails" onClick={() => { sessionStorage.setItem("clientId", dataClient?.user_id); }} className="btn btn-sm btn-primary" >
                                    <i className="fa fa-eye"></i>
                                  </a>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    )}


                  </div>
                  <div class="gridjs-footer">
                    <div class="gridjs-pagination">
                      <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                      <div className="gridjs-pages text-end">
                        {/* Previous Button */}
                        <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                        {/* First Page */}
                        <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                        {/* Ellipsis if needed */}
                        {pagination.current_page > 3 && <span>...</span>}

                        {/* Middle Pages (2 dynamic pages around current) */}
                        {Array.from({ length: 5 }, (_, i) => {
                          const page = pagination.current_page - 2 + i;
                          if (page > 1 && page < pagination.last_page) {
                            return (
                              <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                {page}
                              </button>
                            );
                          }
                          return null;
                        })}

                        {/* Ellipsis if needed */}
                        {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                        {/* Last Page */}
                        {pagination.last_page > 1 && (
                          <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                            onClick={() => handlePageChange(pagination.last_page)}>
                            {pagination.last_page}
                          </button>
                        )}

                        {/* Next Button */}
                        <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /row */}

          </div>
        </div>

        <div className="modal fade" id="exampleModal" tabindex="-1"
          aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title" id="exampleModalLabel1">Deposit History</h6>
                <button type="button" className="btn-close" data-bs-dismiss="modal"
                  aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary"> Company</b></span>
                  </label>
                  <span className="ms-auto">{viewData.company_name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">User ID</b></span>
                  </label>
                  <span className="ms-auto">{viewData.client_id || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">User Name</b></span>
                  </label>
                  <span className="ms-auto">{viewData.client_name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Asset</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_asset || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Netowrk</b></span>
                  </label>
                  <span className="ms-auto">{viewData.network_type || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Deposit Amount</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_amount || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Paid Amount</b></span>
                  </label>
                  <span className="ms-auto">{viewData.paid_amount || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">From Address</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData.from_address
                      ? viewData.from_address.slice(0, 10) + '....' + viewData.from_address.slice(-10)
                      : 'N/A'
                    }
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">To Address</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData.to_address
                      ? viewData.to_address.slice(0, 10) + '....' + viewData.to_address.slice(-10)
                      : 'N/A'
                    }
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Txn Hash</b></span>
                  </label>
                  <span className="ms-auto">
                    <a className="text-primary" href={'https://bscscan.com/tx/' + viewData.txn_hash}>{viewData.txn_hash
                      ? viewData.txn_hash.slice(0, 10) + '....' + viewData.txn_hash.slice(-10)
                      : 'N/A'
                    }</a>
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Status</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData && viewData.status
                      ? viewData.status === 'success' ? (
                        <span className="badge bg-success">success</span>
                      ) : (
                        <span className="badge bg-danger">{viewData.status} </span>
                      ) : 'N/A'
                    }
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Date Time</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData.date_time || 'N/A'}
                  </span>
                </div>


              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-danger"
                  data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>



        <div class="modal fade" id="modaldemo8">
          <div class="modal-dialog modal-dialog-centered text-center" role="document">
            <div class="modal-content modal-content-demo">
              <div class="modal-header">
                <h6 class="modal-title">Edit Deposit</h6><button aria-label="Close" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Company</b></span>
                  </label>
                  <span className="ms-auto">{viewData.company_name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">User ID</b></span>
                  </label>
                  <span className="ms-auto">{viewData.client_id || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">User Name</b></span>
                  </label>
                  <span className="ms-auto">{viewData.client_name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Asset</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_asset || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Network</b></span>
                  </label>
                  <span className="ms-auto">{viewData.network_type || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Deposit Amount</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_amount || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Paid Amount</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editPaidAmount}
                      onChange={(e) => setEditPaidAmount(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">From Address</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editFromAddress}
                      onChange={(e) => setEditFromAddress(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">To Address</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editToAddress}
                      onChange={(e) => setEditToAddress(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Txn Hash</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editTxnHash}
                      onChange={(e) => setEditTxnHash(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Status</b></span>
                  </label>
                  <span className="ms-auto">
                    <select
                      className="form-control"
                      value={editStatus}
                      onChange={(e) => setEditStatus(e.target.value)}
                    >
                      <option value="open">Open</option>
                      <option value="success">Success</option>
                      <option value="failed">Failed</option>
                    </select>
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Date Time</b></span>
                  </label>
                  <span className="ms-auto">{viewData.date_time || 'N/A'}</span>
                </div>
                <span>{error}</span>
              </div>

              <div className="modal-footer">
                <button className="btn btn-primary" onClick={updateDeposit}>Save changes</button>
                <button className="btn btn-light" data-bs-dismiss="modal">Close</button>
              </div>

            </div>
          </div>
        </div>
        <ToastContainer />
      </Header>


      <Footer />

    </>
  )
}

export default Client